import React from "react";
import classNames from "classnames";
import { InputGroup } from "react-bootstrap";
import PropTypes from "prop-types";

import "./styles.scss";

const MyDpdInputGroup = ({ className, children, prepend, append }) => {
  return (
    <InputGroup className={classNames("mydpd-input-group", className)}>
      {prepend && (
        <InputGroup.Prepend className="prepend-container">
          {prepend}
        </InputGroup.Prepend>
      )}
      {children}
      {append && (
        <InputGroup.Append className={classNames("append-container")}>
          {append}
        </InputGroup.Append>
      )}
    </InputGroup>
  );
};

Object.assign(MyDpdInputGroup, InputGroup);

MyDpdInputGroup.propTypes = {
  children: PropTypes.node,
  prepend: PropTypes.element,
  append: PropTypes.element,
  className: PropTypes.string,
};

export default MyDpdInputGroup;
